import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { getConfigFerramentas } from '../utils/configFerramentas';
import ConfigsContext from '../contexts/ConfigsContext';

/**
 * FerramentaGuard
 * ===============
 * Bloqueia a rota de um módulo opcional ("Ferramenta") quando a flag da loja
 * está desativada (padrão de quase todas; ver `padrao` em configFerramentas).
 * As flags vêm do servidor por loja (/v1/configs/all) e são gerenciadas em
 * Configurações > Ferramentas; aqui a leitura é síncrona do cache local.
 *
 * Uso: <FerramentaGuard flag="alertas"><Alertas /></FerramentaGuard>
 */
const FerramentaGuard = ({ flag, children }) => {
  const ctx = useContext(ConfigsContext);
  const cfg = getConfigFerramentas();
  if (!cfg[flag]) {
    // Computador novo: o cache ainda esta no default ate o /v1/configs/all
    // responder. Espera em vez de mandar para o dashboard por engano.
    if (ctx && !ctx.loaded) return null;
    return <Navigate to="/inicio/dashboard" replace />;
  }
  return children;
};

FerramentaGuard.propTypes = {
  flag: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default FerramentaGuard;
